import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { StarMark } from "@/components/Logo";
import { waLink, MESSAGES } from "@/constants/site";

const EASE = [0.22, 1, 0.36, 1];

export const FinalCTA = () => (
  <section id="contato" data-testid="final-cta-section" className="relative overflow-hidden bg-[#F7F4EF] py-24 lg:py-32">
    <StarMark className="pointer-events-none absolute -left-16 top-10 h-64 w-64 opacity-[0.07]" />
    <StarMark className="pointer-events-none absolute -bottom-20 -right-10 h-80 w-80 opacity-[0.07]" />
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease: EASE }}
      className="relative mx-auto max-w-3xl px-5 text-center sm:px-8"
    >
      <p className="mb-5 text-xs font-bold uppercase tracking-[0.3em] text-[#121212]">
        Atendimento Personalizado
      </p>
      <h2 className="font-display text-3xl font-semibold tracking-tight text-[#121212] sm:text-4xl lg:text-5xl">
        ENCONTRE A OPÇÃO <span className="italic text-gold-gradient-dark">IDEAL</span> PARA VOCÊ!
      </h2>
      <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#5c5952] sm:text-lg">
        Nossa equipe está pronta para ajudar você a escolher a melhor opção para
        o seu estilo e a sua necessidade.
      </p>
      <motion.a
        href={waLink(MESSAGES.especialista)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="final-cta-whatsapp-btn"
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.96 }}
        className="group relative mt-10 inline-flex items-center gap-3 overflow-hidden rounded-full bg-[#0A0A0B] px-9 py-5 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F9F8F6] shadow-[0_15px_50px_rgba(10,10,11,0.3)]"
      >
        <span className="absolute inset-0 -translate-x-full bg-[#D4AF37]/20 transition-transform duration-500 group-hover:translate-x-0" />
        <WhatsAppIcon className="relative h-5 w-5" />
        <span className="relative">Falar com uma especialista no WhatsApp</span>
      </motion.a>
    </motion.div>
  </section>
);
